<ng-container *ngIf="!modalLayout && (staticDisplay$ | async); else summaryFloatingDisplay">
  <rx-summary-panel-static
    [showButton]="showButton"
    [disableButton]="disableButton"
    [hotelName]="hotelName"
    [thumbnailUrl]="thumbnailUrl"
    [hotelId]="hotelId"
    [adultsAmount]="adultsAmount"
    [rooms]="rooms"
    [totalPrice]="totalPrice"
    [checkInDate]="checkInDate"
    [checkOutDate]="checkOutDate"
    [dateFormat]="dateFormat"
    [salesTax]="salesTax"
    (clickButton)="clickButton.emit()"
    [saverPlusFee]="saverPlusFee"
    [nightsAmount]="nightsAmount"
    [sameDayRateEnabled]="saverplusSameDayRate$ | async"
    [taxesAndFeesLayout]="taxesAndFeesLayout"
    [hideDueAtCheckIn]="hideDueAtCheckIn"
  >
    <ng-content />
  </rx-summary-panel-static>
</ng-container>

<ng-template #summaryFloatingDisplay>
  <rx-summary-panel-room-floating
    *ngIf="!taxesAndFeesService.hasTaxsAndFeesBreakdown(taxesAndFeesLayout, rooms)"
    [ngClass]="{ 'container fixed-bottom': !modalLayout }"
    showButton="true"
    [disableButton]="disableButton"
    [hotelName]="hotelName"
    [thumbnailUrl]="thumbnailUrl"
    [hotelId]="hotelId"
    [adultsAmount]="adultsAmount"
    [rooms]="rooms"
    [totalPrice]="totalPrice"
    [checkInDate]="checkInDate"
    [checkOutDate]="checkOutDate"
    (clickButton)="clickButton.emit()"
    [saverPlusFee]="saverPlusFee"
  >
  </rx-summary-panel-room-floating>

  <rx-applications-taxes-and-fees-payment-summary-mobile
    *ngIf="taxesAndFeesService.hasTaxsAndFeesBreakdown(taxesAndFeesLayout, rooms)"
    [ngClass]="{ hideDueAtCheckIn: hideDueAtCheckIn }"
    [rooms]="rooms"
    [disableButton]="disableButton"
    [isBodyExpanded]="rooms?.length"
    [hideDueAtCheckIn]="hideDueAtCheckIn"
    (clickButton)="clickButton.emit()"
  ></rx-applications-taxes-and-fees-payment-summary-mobile>
</ng-template>
